
export const LANGUAGE_STORAGE_KEY = 'menu_language';

export const defaultLanguage = 'fr';

export const fallbackLanguage = 'fr';

export const supportedLanguages = [
  {
    code: 'fr',
    label: 'Français',
    direction: 'ltr',
  },
  {
    code: 'ar',
    label: 'العربية',
    direction: 'rtl',
  },
  {
    code: 'en',
    label: 'English',
    direction: 'ltr',
  },
  {
    code: 'es',
    label: 'Español',
    direction: 'ltr',
  },
  {
    code: 'de',
    label: 'Deutsch',
    direction: 'ltr',
  },
  {
    code: 'zh',
    label: '中文',
    direction: 'ltr',
  },
  {
    code: 'ru',
    label: 'Русский',
    direction: 'ltr',
  },
  {
    code: 'nl',
    label: 'Nederlands',
    direction: 'ltr',
  },
  {
    code: 'ja',
    label: '日本語',
    direction: 'ltr',
  },
  {
    code: 'it',
    label: 'Italiano',
    direction: 'ltr',
  },
  {
    code: 'pt',
    label: 'Português',
    direction: 'ltr',
  },
  {
    code: 'tr',
    label: 'Türkçe',
    direction: 'ltr',
  },
];

export const supportedLanguageCodes = supportedLanguages.map(
  (language) => language.code,
);
